import { render, staticRenderFns } from "./IOTStartupActivities.vue?vue&type=template&id=740f3272"
import script from "./IOTStartupActivities.vue?vue&type=script&lang=js"
export * from "./IOTStartupActivities.vue?vue&type=script&lang=js"
import style0 from "./IOTStartupActivities.vue?vue&type=style&index=0&id=740f3272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports